import { ApiClient } from '../../core/api/ApiClient';
import { API_BASE_URL } from '../../core/config/api';
import LogUtil from '../../core/utils/LogUtil';
import { PaymentRepositoryImpl } from './implementations';
import { PaymentService } from './services';

// Payment Domain Exports
export * from './implementations';
export * from './interfaces';
export * from './services';

/**
 * Payment Domain Dependency Injection Container
 * 의존성 주입을 통한 클린 아키텍처 구현
 */
class PaymentDomainContainer {
  constructor() {
    this._apiClient = null;
    this._paymentRepository = null;
    this._paymentService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      this._apiClient = new ApiClient(API_BASE_URL);
      LogUtil.log('🔧 [Payment Container] ApiClient 초기화 완료:', API_BASE_URL);
    }
    return this._apiClient;
  }

  get paymentRepository() {
    if (!this._paymentRepository) {
      this._paymentRepository = new PaymentRepositoryImpl(this.apiClient);
      LogUtil.log('🔧 [Payment Container] PaymentRepositoryImpl 초기화 완료');
    }
    return this._paymentRepository;
  }

  get paymentService() {
    if (!this._paymentService) {
      this._paymentService = new PaymentService(this.paymentRepository);
      LogUtil.log('🔧 [Payment Container] PaymentService 초기화 완료');
    }
    return this._paymentService;
  }

  /**
   * 컨테이너 초기화 (테스트용)
   */
  reset() {
    this._apiClient = null;
    this._paymentRepository = null;
    this._paymentService = null;
  }
}

// Singleton 인스턴스
const container = new PaymentDomainContainer();

/**
 * Payment Service 싱글톤 접근자
 * @returns PaymentService 인스턴스
 */
export const getPaymentService = () => container.paymentService;

/**
 * Payment Repository 싱글톤 접근자 (테스트용)
 * @returns PaymentRepositoryImpl 인스턴스
 */
export const getPaymentRepository = () => container.paymentRepository;

/**
 * 컨테이너 리셋 (테스트용)
 */
export const resetPaymentContainer = () => container.reset();
